<div class="chart-slide body" #innerBody>

    <!-- ============================================================
         Summary table — one row, mirroring the package details table.
         ============================================================ -->
    @if (getOfferSummaryRow() != null) {
    <div class="prices-stats-block">
        <table mat-table
               [dataSource]="[getOfferSummaryRow()!]"
               class="offer-summmary-table in-card-table background-transparent">

            <ng-container matColumnDef="Price">
                <th mat-header-cell *matHeaderCellDef style="text-align: left !important">$/kWh</th>
                <td class="f14" mat-cell *matCellDef="let row">
                    {{row.price | currency:'USD':'symbol':'1.5-5'}}
                </td>
            </ng-container>

            <ng-container matColumnDef="ServiceStart">
                <th mat-header-cell *matHeaderCellDef style="text-align: left !important">Service Start</th>
                <td class="f14" mat-cell *matCellDef="let row">
                    {{row.termFrom | date:'shortDate'}}
                </td>
            </ng-container>

            <ng-container matColumnDef="ServiceEnd">
                <th mat-header-cell *matHeaderCellDef style="text-align: left !important">Service End</th>
                <td class="f14" mat-cell *matCellDef="let row">
                    {{row.termTo | date:'shortDate'}}
                </td>
            </ng-container>

            <ng-container matColumnDef="Term">
                <th mat-header-cell *matHeaderCellDef style="text-align: left !important">Term</th>
                <td class="f14" mat-cell *matCellDef="let row">
                    {{row.term}} mths
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="summaryColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: summaryColumns;"></tr>

        </table>
    </div>
    }

    <!-- ============================================================
         Yellow tile — same markup as in main-user-home.html, placed
         below the table and above the carousel.
         ============================================================ -->
    @if (selectedOffer != null) {
    <div class="price-info chat-info-shadow selected button mt-10" [style]="'background-color:'+getKilowantColor()">
        <div class="caption" [innerHTML]="offerInfoText(selectedOffer, false)">
        </div>
    </div>
    }

    @if (account()!=null && sliderData!=null && sliderData.length>0) {
    <div style="margin-top: -30px; z-index:1000; position: relative;">
        <owl-carousel-o [class]="'offerSummarySlide mb-4 owl-theme'+((currentPosition()<positionOfNowSlide())?' prev-active':((currentPosition()>positionOfNowSlide())?' next-active':''))"
                        [options]="sliderOptions()" (changed)="sliderChange($event)" #slider>
            @for (sliderRecord of sliderData; track sliderRecord; let i = $index) {
            <ng-template carouselSlide [id]="i.toString()">
                @if (sliderExtension[i]) {
                <div class="item pb-4 custom-owl-item text-center">
                    <div>
                        <div class="block-buttons full-width">
                            @if (!sliderRecord.showCounterButton) {
                            <button (click)="gotoSellOffer(i)" class="selected">
                                Proceed with Offer
                            </button>
                            }
                            @if (sliderRecord.showUpdateButton) {
                            <button (click)="gotoEditBuyOffer(i)">Update Order</button>
                            }
                            @if (sliderRecord.showCounterButton) {
                            <button (click)="intergatedSelection(i, 0)" [class]="(integratedButtonSelected()==0)?'selected':''">
                                Accept Offer
                            </button>
                            }
                            @if (sliderRecord.showCounterButton) {
                            <button (click)="intergatedSelection(i, 1)" [class]="(integratedButtonSelected()==1)?'selected':''">
                                Counter Offer
                            </button>
                            }
                        </div>
                    </div>
                    <div class="row">
                        @if (sliderRecord.rates.length > 0) {
                        <div class="chart-basis">
                            <kilowant-charts-home-accept-offer [view]="view()" [legend]="legend()" [legendTitle]="legendTitle()"
                                                               [legendPosition]="legendPosition()" [showGridLines]="true" [showDataLabel]="false"
                                                               [scheme]="colorScheme()" [showXAxisLabel]="showXAxisLabel()" [showYAxisLabel]="showYAxisLabel()"
                                                               [xAxis]="xAxis()" [yAxis]="yAxis()" [xAxisLabel]="xAxisLabel()" [yAxisLabel]="yAxisLabel()"
                                                               [groupPadding]="8" [barPadding]="4" [noBarWhenZero]="true"
                                                               [valLabel]="(this.sliderExtension[i].line1)?this.sliderExtension[i].line1!.title:((this.sliderExtension[i].line2)?((this.integratedButtonSelected()==0)?this.sliderExtension[i].line2!.title:'Counter Offer'):'')"
                                                               [valColor]="(this.sliderExtension[i].line1)?this.sliderExtension[i].line1!.color:((this.sliderExtension[i].line2)?getKilowantColor():'')"
                                                               [leftShift]="(this.sliderExtension[i].line1)?[this.sliderExtension[i].line1!.leftShift]:((this.sliderExtension[i].line2)?[this.sliderExtension[i].line2!.leftShift]:[])"
                                                               [rightShift]="(this.sliderExtension[i].line1)?[this.sliderExtension[i].line1!.rightShift]:((this.sliderExtension[i].line2)?[this.sliderExtension[i].line2!.rightShift]:[])"
                                                               [showNormalChatout]="(this.sliderExtension[i].line1)?this.sliderExtension[i].line1!.hasCallout:(this.sliderExtension[i].line2)?this.sliderExtension[i].line2!.hasCallout:false"
                                                               (valLink)="chartLineFunction(i)"
                                                               [shadow]="true"
                                                               [nextRate]="(sliderExtension[i].rightText1)?((integratedButtonSelected()==0)?sliderExtension[i].rightText1!.val:sliderExtension[i].rightText1!.val*0.9):0"
                                                               [nextRateColor]="(sliderExtension[i].rightText1)?getKilowantColor():''"
                                                               [nextRateLabel]="(sliderExtension[i].rightText1)?((integratedButtonSelected()==0)?sliderExtension[i].rightText1!.title:'Counter Offer'):''"
                                                               [showNextRateCallout]="(sliderExtension[i].rightText1)?sliderExtension[i].rightText1!.hasCallout:false"
                                                               (gotoNext)="(sliderExtension[i].rightText1 && sliderExtension[i].rightText1!.funcLink())?sliderExtension[i].rightText1!.funcLink():null"
                                                               (gotoCurrent)="goToNowSlide()"
                                                               [utilityAverageRate]="sliderRecord.utilityAveragePrice"
                                                               [myContractRate]="(currentCost()==null || currentCost()!.price==null || currentCost()!.price==0 || sliderRecord.isCurrent || i==0)?0:currentCost()!.price!"
                                                               [myContractInFuture]="!sliderRecord.isFuture"
                                                               [communityAverageRate]="sliderRecord.communityAveragePrice"
                                                               [prefix]="i.toString()"
                                                               [results]="sliderRecord.activeRates"
                                                               [datasetSelector]="sliderRecord.countRates()>1"
                                                               [selectedDatasets]="selectedDatasets()"
                                                               [utilityWarningDate]="latestUtilityDate()"
                                                               [communityWarningDate]="latestCommunityDate()"
                                                               [tooltipDisabled]="true"
                                                               (datasetChanged)="changeDataset($event)">
                            </kilowant-charts-home-accept-offer>
                        </div>
                        }
                    </div>
                </div>
                }
            </ng-template>
            }
        </owl-carousel-o>
    </div>
    }
</div>